import axios from 'axios';

export function getConfigAsync() {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/loginConfig/getList", {})
        .then(response => {
          let result = {};
          if (response && response.data && response.data.rows && response.data.rows.length > 0) {
            result = response.data.rows[0];
          }
          resolve(result);
        })
        .catch(error => {
          reject(error);
          // this.$message.error("数据获取失败");
          console.log("error:" + error.toString());
        });
    });
}


export function getCategoryListAsync(key) {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/category/getCategoryList/key?value="+key)
      .then(response => {
        resolve((response.data.data||[]));
      })
      .catch(error => {
        reject(error);
        // this.$message.error("数据获取失败");
        console.log("error:" + error.toString());
      });
  });
}

/**
 * //处理小数点 num数字，dotlength小数点长度
 */
export function dealDot(num,dotlength){
	let numStr=""+num;
	if(!dotlength){
		dotlength=0;
	}
	if(!numStr){
		return 0;
	}
	if((numStr).indexOf('.')>-1){
		let rightDot=numStr.split('.')[1];
		let leftDot=numStr.split('.')[0];
		if(rightDot && rightDot.length>dotlength){
		rightDot= rightDot.substring(0,dotlength);
		}
		num= Number(leftDot+ '.' + rightDot);
	}
	return num;
}


export function asyncMethod(url,data,method) {
  return new Promise((resolve, reject) => {
    axios({
      method: (method||'get'),
      url,
      data
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
        // this.$message.error("数据获取失败");
        console.log("error:" + error.toString());
      });
  });
}
export async function asyncMethodS(data, url, method) {
  let headers={};
  let res =await axios({
      method: (method ? method : 'get'),
      url:url,
      data:data,
      headers,
  })
  .then((response) => {
      return (response.data);
  })
  .catch((error) => {
      console.log('服务器错误');
      throw new Error("");
  });
  return res 
}


// WEBPACK FOOTER //
// ./src/js/common.js